export const APIConfiguration = {
  SUCCESS_HTTP_STATUS: 200,
  CREATED_HTTP_STATUS: 201,
  UNAUTHORIZED_HTTP_STATUS: 401,
  ACCESS_FORBIDDEN_HTTP_STATUS: 403,
  NO_DATA_FOUND_HTTP_STATUS: 404,
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500,
  CONFLICT_ERROR: 409,
  NO_SELECTION: 204,
  REQUEST_TIMEOUT: 408
}
